export const WHITELISTED_ENDPOINTS = [
  '/ybl/customer-details',
  '/ocr-address',
  '/address',
  '/ocr-details-update'
];

export const isWhitelisted = (url) =>
  WHITELISTED_ENDPOINTS.some(endpoint => url.includes(endpoint));


/**
 * WHITELISTED_ENDPOINTS_REQUEST
 *
 * This list contains API endpoints that are exempted from certain request interceptor behaviors
 * (e.g., authentication checks, request transformations, or error handling middleware).
 *
 * Use cases:
 * - Currently this to whitelist the APIs which don't need certain parts to be decamelized. For eg. countryCode is not decamelized. eg US -> u_s will be avoided here
 *
 * Note: Add endpoints here only when they require special handling in the request pipeline.
 */
export const WHITELISTED_ENDPOINTS_REQUEST = [
  '/api/v1/timeline-settlement/fulfillment-settlements/update-timelines',
  'fx-service-manager/fx-rates-config/update'
]

export const isWhitelistedReq = (url) => 
  WHITELISTED_ENDPOINTS_REQUEST.some(endpoint => 
    url.includes(endpoint));